import { render, staticRenderFns } from "./SearchCheckbox.vue?vue&type=template&id=56a9a453&"
import script from "./SearchCheckbox.vue?vue&type=script&lang=js&"
export * from "./SearchCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports